import { Course } from "@/common/course/types";
import { CourseRun } from "@/common/courseRun/types";

/**
 * Select the advertised run for a course: prefer advertisedCourseRunUuid (run.uuid),
 * then canonicalCourseRunKey (run.key), and finally fall back to the first course run.
 */
export function getAdvertisedCourseRun(course: Course): CourseRun | undefined {
  if (!course.courseRuns?.length) {
    return undefined;
  }
  if (course.advertisedCourseRunUuid) {
    const run = course.courseRuns.find(
      (r) => r.uuid === course.advertisedCourseRunUuid,
    );
    if (run) {
      return run;
    }
  }
  if (course.canonicalCourseRunKey) {
    const run = course.courseRuns.find(
      (r) => r.key === course.canonicalCourseRunKey,
    );
    if (run) {
      return run;
    }
  }
  return course.courseRuns[0];
}
